import { DocumentOcrQualityTag, useCitationOcrQuality } from '@heidi/evidence';
import type { SimpleCitation } from '@heidi/evidence/contracts';

/**
 * Port 8. ONE component slot rather than a resolver, because
 * `useCitationOcrQuality` is a hook reading a library feature flag and a
 * resolver port would have package render call an app hook. Renders nothing
 * unless the citation is a user document with a recorded quality problem — the
 * condition the two card layouts used to spell out themselves.
 */
export const CitationOcrQualityTag = ({ citation }: { citation: SimpleCitation }) => {
  const quality = useCitationOcrQuality(
    citation.source_type === 'user_document'
      ? citation.text_extraction_quality
      : undefined
  );
  if (!quality) return null;
  return <DocumentOcrQualityTag quality={quality} />;
};
